window.quotationTypeChanged = () => {
    quotationShowConditionalFields();
}

window.quotationShowConditionalFields = () => {
    $(".conditional").hide()
    qtype = $('#quotation_quotation_type :selected').text().toLowerCase();
    $(".conditional.".concat(qtype)).show()
}
